const HEADER = document.getElementById('header');
const HEADER_LOGO = document.querySelector('#headerLogo img');
const HEADER_LOGO_URL = HEADER_LOGO.getAttribute('src');

console.log(HEADER_LOGO.dataset.scroll);

checkPage();

window.addEventListener('scroll', function () {
    checkPage();
});

function checkPage(){
	if (document.documentElement.scrollTop > 20) {
		HEADER.classList.add('bg-secondary', 'scroll');
	}

	if( !document.querySelector('body.notopcontent') ){
		scrollW();
	} else {
		HEADER.classList.add('bg-secondary', 'scroll');
		changeSrc(HEADER_LOGO.dataset.scroll);
	}
}

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 20) {
		HEADER.classList.add('bg-secondary', 'scroll');
		changeSrc(HEADER_LOGO.dataset.scroll);
	} else {
		HEADER.classList.remove('bg-secondary', 'scroll');
		changeSrc();
	}
	
}
function changeSrc(newURL) {
	HEADER_LOGO.setAttribute('src', newURL ? newURL : HEADER_LOGO_URL);
}

